import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'replaceBoolean'
})
export class ReplaceBooleanPipe implements PipeTransform {

  transform(value: boolean): unknown {
    if (value)
      return 'YES';
    return 'NO';
  }

}
